export default __webpack_public_path__ + "locales/pl/EmptyView.json?hash=343a924724145a1b7b875f8f00db0a8d";